export const addDetails = (units) => {
  Object.keys(units).forEach(unitType => {
    let positive = 0, negative = 0, bgColor
    const registers = units[unitType]?.registers.map(register => {
      const diff = (new Date() - new Date(register?.datetime || register?.time_stamp))/60000 < 15
      if(diff) positive++
      else negative++
      return {
        ...register,
        name: register?.name ? register.name : register.idDevice,
        percentage: parseFloat(register?.percentage),
        connection: diff,
        device: register?.device || register?.idDevice,
        last24hrs: []
      }
    })
    const total = positive + negative
    if(negative > positive) bgColor = 'bad'
    else if(((negative * 100) / total) > 25) bgColor = 'regular'
    else bgColor = 'good'

    units[unitType] = {
      ...units[unitType],
      positive,
      negative,
      bgColor,
      registers
    }
  })
  return units
}